import { useCallback } from 'react'
import { useMutation } from '@apollo/client/react'
import { AdminAPI } from '@guestgoodie/graphql'

import { formToGraphql, FormTranslations } from '@/features/translations'

export type FormData = {
  name: string
  translations: FormTranslations
}

export function useBanner(id?: number) {
  const [createBanner, { loading: createLoading }] = useMutation(
    AdminAPI.banner.CREATE,
    {
      refetchQueries: [AdminAPI.banner.GET_ALL]
    }
  )

  const [updateBanner, { loading: updateLoading }] = useMutation(
    AdminAPI.banner.UPDATE
  )

  const [deleteBanner, { loading: deleteLoading }] = useMutation(
    AdminAPI.banner.DELETE,
    {
      refetchQueries: [AdminAPI.banner.GET_ALL]
    }
  )

  const create = useCallback(
    (data: FormData) => {
      createBanner({
        variables: {
          input: {
            name: data.name,
            translations: formToGraphql(data.translations)
          }
        }
      })
    },
    [createBanner]
  )

  const update = useCallback(
    (data: FormData) => {
      if (!id) return

      updateBanner({
        variables: {
          input: {
            id,
            ...data,
            translations: formToGraphql(data.translations)
          }
        }
      })
    },
    [id, updateBanner]
  )

  const remove = useCallback(() => {
    if (!id) return

    deleteBanner({
      variables: {
        id
      }
    })
  }, [id, deleteBanner])

  return {
    create,
    update,
    remove,
    createLoading,
    updateLoading,
    deleteLoading
  }
}
